import {
  Component,
  ContentChild,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { DialogComponent } from '../dialog/dialog.component';
import { DescargoOssa } from '@/app/models/interface/descargo-ossa.model';

@Component({
  selector: 'c-descargo-card',
  templateUrl: './descargo-card.component.html',
  styleUrl: './descargo-card.component.css',
  standalone: false,
})
export class DescargoCardComponent {
  @Input() titulo!: string;

  @ContentChild('contenidoHtml') contenidoHtml!: TemplateRef<any>;

  isCollapsed = true;
  visible = false;

  @Input() estado: number = 0;

  respuesta: string = '';
  newEstado: number = 0;

  show(newEstado: number) {
    this.newEstado = newEstado;
    this.visible = true;
  }

  @Output() sendRespuesta = new EventEmitter<Partial<DescargoOssa>>();

  close() {
    this.visible = false;
    this.respuesta = '';
    this.newEstado = 0;
  }

  @ViewChild('dialog') dialog!: DialogComponent;

  newOssa: boolean = false; //estado
  descargoOssa: number = 0;

  error = false;
  setValues() {
    this.error = false;
    if (this.respuesta)
      this.dialog.confirm(
        '¿Está seguro / a de enviar la respuesta cargada?',
        'Cambio de estado en descargos',
        () => {
          this.sendRespuesta.emit({
            estado: this.newEstado,
            respuesta: this.respuesta,
          });

          this.visible = false;
        },
        () => {
          this.visible = false;
        },
      );
    else this.error = true;
  }
}
